import { render, staticRenderFns } from "./WidgetGift.vue?vue&type=template&id=7db1b8c8&"
import script from "./WidgetGift.vue?vue&type=script&lang=ts&"
export * from "./WidgetGift.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports